import React from 'react';
import Hero from './components/researchbiotechphd/Hero';
import Main from './components/researchbiotechphd/Main';

const Research = () => {
    return (
        <div>
            <Hero />
            <Main />
        </div>
    )
}

export default Research;